import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useNavigate, useLocation, matchPath } from "react-router-dom";
import "./login.css";
import ConnectButton from "./walletLogin/ConnectButton";
import { useAppKitAccount } from "@reown/appkit/react";

const LoginPopUp = ({ onClose, signupUrl, onSignUp }) => {
    const [isReferrer, setIsReferrer] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const { address, isConnected } = useAppKitAccount();

    const loginSource = sessionStorage.getItem("loginSource");

    const handleSignUpNow = () => {
        if (onSignUp) onSignUp();
        else if (signupUrl) navigate(signupUrl);
        else navigate("/login");
    };

    const handleContinueWithGoogle = () => {
        const redirectAfterLogin = sessionStorage.getItem("originalUrl");
        fetch(`${process.env.REACT_APP_API_URL}/initiategooglelogin?state=${encodeURIComponent(redirectAfterLogin)}`)
            .then((res) => res.json())
            .then((res) => {
                if (res.google_url) window.location.replace(res.google_url);
            });
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const referrerId = urlParams.get("ref");
        if (referrerId) setIsReferrer(true);

        document.body.style.overflow = "hidden"; // prevent scroll
        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);

    const getText = () => {
        if (loginSource) sessionStorage.removeItem("loginSource");
        if (loginSource === "addToPortfolio") return "Add Your Portfolio for Best Buy-Sell Recommendations";
        if (location.pathname === "/predict-now") return "Predict accurately and win $wisecoins worth $5";
        if (
            location.pathname === "/my-portfolio/detailed-portfolio-analysis" ||
            location.pathname === "/audit-my-portfolio"
        ) return "Add Your Portfolio for Best Buy-Sell Recommendations";
        if (matchPath("/crypto/:crypto", location.pathname) || location.pathname === "/crypto-screener")
            return "Premium Signals @ $1 per month";
        return "Sign up and Earn 1000 Wisecoins";
    };

    const popup = (
        <div className="popup-overlay">
            <div className="popup-content">
                <button className="popup-close-btn" onClick={onClose}>×</button>

                <img
                    src={`${window.constants.asset_path}/images/logo.png`}
                    alt="Wise coins logo"
                    className="popup-logo"
                />

                <p className="popup-text"><strong>{getText()}</strong></p>

                <button className="google-button" onClick={handleContinueWithGoogle}>
                    <img src={`${window.constants.asset_path}/images/google.svg`} alt="Google logo" />
                    Continue With Google
                </button>

                {/* <ConnectButton /> */}
                <hr className="popup-divider" />
                <div className="popup-links">
                    <a href="https://investing.crowdwisdom.live/termofuse">Terms of Use</a>
                    <a href="https://investing.crowdwisdom.live/privacyPolicy">Privacy Policy</a>
                </div>
            </div>
        </div>
    );

    return ReactDOM.createPortal(popup, document.body);
};

export default LoginPopUp;
